import './meet.scss';
import Swiper from 'swiper/bundle';

export default () => {

	const slides = document.querySelectorAll('.js-meet-slider .js-meet-slide')
	//Slider

	slides.forEach(slide=>{
		const container = slide.querySelector('.meet__slider-holder');

		slide.querySelector('.meet__slider-point').addEventListener('input', (e) => {
			container.style.setProperty('--position', `${e.target.value}%`);
		})
		container.style.setProperty('--position', `50%`);
	})

	//Swiper
	let swiper = new Swiper('.js-meet-slider', {
		speed: 500,
		slidesPerView: 1,
		centeredSlides: true,
		navigation: {
			nextEl: ".meet-button-next",
			prevEl: ".meet-button-prev",
		},
	});

	document.querySelectorAll('.meet__slider-point')
	        .forEach(el => {
		        el.addEventListener('touchstart', () => {
			        swiper.allowTouchMove = false;
		        });
		        el.addEventListener('touchend', () => {
			        swiper.allowTouchMove = true;
		        });
	        });

};
